export default __webpack_public_path__ + "static/media/pizza_html_css.1794592e.PNG";